import React from 'react';

import './LoadMore.scss';
import * as PropTypes from 'prop-types';
import { Router } from '../../router';
import R from '../../lib/routes';
import { incrementArticlesPage } from '../../actions/articles';
import { classNamer } from '../../lib/utils';
import { Button, BUTTON_VARIANTS } from './Button';
import i18n from '../../translations/i18n';

const cn = classNamer('LoadMore');

const routes = {
  [R.blog]: {
    incrementPage: () => incrementArticlesPage(R.blog),
  },
  [R.news]: {
    incrementPage: () => incrementArticlesPage(R.news),
  },
  [R.knowledgeBase]: {
    incrementPage: () => incrementArticlesPage(R.knowledgeBase),
  },
};

const LoadMore = ({ route, page, totalPages }) => {
  const onLoadMore = () => {
    routes[route].incrementPage();
    Router.push(route);
  };

  if (totalPages <= page) {
    return null;
  }

  return (
    <div className={cn()}>
      <Button variant={BUTTON_VARIANTS.primary} onClick={onLoadMore}>
        {i18n.loadMoreArticles}
      </Button>
    </div>
  );
};

LoadMore.propTypes = {
  route: PropTypes.string,
  totalPages: PropTypes.number,
  page: PropTypes.number,
};

export default LoadMore;
